<template>
  <b :class="[this.currentCall == 'unlimited' ? 'd-none' : null]">{{
    currentCall
  }}</b>
  <span :class="[this.currentCall == 'unlimited' ? 'd-none' : null]"
    >/{{ maxValue }}</span
  >
  <div
    :class="[this.currentCall == 'unlimited' ? 'd-none' : 'customProgressBar']"
  >
    <div
      :class="[
        this.currentCall == 'unlimited'
          ? 'd-none'
          : progressBarChecker(currentCall),
      ]"
      :style="{
        width:
          (parseInt(this.currentCall) * 100) / parseInt(this.maxValue) + 'px',
      }"
    ></div>
  </div>
  <div class="position-relative">
    <div
      :class="[
        this.currentValue == 'unlimited'
          ? 'customProgressBar-unlimited'
          : 'd-none',
      ]"
    ></div>
  </div>
</template>

<script>
import SIMService from "../../common/services/simService";

export default {
  props: ["simId", "maxValue", "currentValue"],
  methods: {
    progressBarChecker(currentValue) {
      if (parseInt(currentValue) > 50) {
        return "customProgressBar-red";
      } else {
        return "customProgressBar-green";
      }
    },
  },
  data() {
    return {
      currentCall: 0,
    };
  },
  mounted() {
    SIMService.getSubscriberSIMServiceInfo(this.simId).then(
      (response) =>
        (this.currentData = response.data.BALANCEDETAIL.TOTALBALANCE.TALK)
    );
  },
};
</script>

<style>
@import "./../../assets/styles/helpers/progressBar.css";
</style>
